// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Allows .table-responsive to manage its own overflow */
}

.table-responsive {
  overflow-x: auto; /* Allows horizontal scrolling */
  overflow-y: auto; /* Allows vertical scrolling */
  /* Adjust max-height based on the available space, consider header/footer height etc. */
  max-height: calc(100vh - 250px); /* Adjust 250px based on the actual space the header/footer takes */
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead tr {
  background-color: #233880ba;
  color: white;
}

td, th {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tbody tr:hover {
  background-color: #f5f5f5;
}

tfoot {
  border-top: 1px solid #ddd;
}

tfoot td {
  padding: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Set padding as needed, but do not use margin here if it creates unwanted space */
  padding: 10px;
}

/* If buttons are disabled (first page, last page scenarios) */
button:disabled {
  color: grey;
  cursor: not-allowed;
}

/* Media query adjustments for responsiveness */
@media (max-width: 600px) {
  td, th {
    padding: 14px;
  }

  .pagination {
    flex-direction: column;
    align-items: stretch;
  }
  
  .pagination button,
  .pagination select,
  .pagination input {
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Table.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,wDAAwD;AAC5E;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,gBAAgB,EAAE,8BAA8B;EAChD,uFAAuF;EACvF,+BAA+B,EAAE,mEAAmE;AACtG;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mFAAmF;EACnF,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,mBAAmB;EACrB;AACF","sourcesContent":[".table-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* Allows .table-responsive to manage its own overflow */\n}\n\n.table-responsive {\n  overflow-x: auto; /* Allows horizontal scrolling */\n  overflow-y: auto; /* Allows vertical scrolling */\n  /* Adjust max-height based on the available space, consider header/footer height etc. */\n  max-height: calc(100vh - 250px); /* Adjust 250px based on the actual space the header/footer takes */\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead tr {\n  background-color: #233880ba;\n  color: white;\n}\n\ntd, th {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\ntbody tr:hover {\n  background-color: #f5f5f5;\n}\n\ntfoot {\n  border-top: 1px solid #ddd;\n}\n\ntfoot td {\n  padding: 10px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* Set padding as needed, but do not use margin here if it creates unwanted space */\n  padding: 10px;\n}\n\n/* If buttons are disabled (first page, last page scenarios) */\nbutton:disabled {\n  color: grey;\n  cursor: not-allowed;\n}\n\n/* Media query adjustments for responsiveness */\n@media (max-width: 600px) {\n  td, th {\n    padding: 14px;\n  }\n\n  .pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .pagination button,\n  .pagination select,\n  .pagination input {\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
